import { makeRequestHook } from '../../common';
import { sendResetPasswordLink } from '../network';

export const useSendResetPasswordLink = makeRequestHook(sendResetPasswordLink);
